import React, { FC } from 'react'

const ErrorComponent : FC = () => {
    return (
        <div>
            <h5>404</h5>
        </div>
    )
}

export default ErrorComponent
